import { useState } from 'react'
import Icons from '../icons/Icons'
import Answer from '../answer/Answer'

const Question = ({ ...props }) => {

    const info = props.info.row.original ?? {}
    const [ isCollapsed, setIsCollapsed ] = useState( false ) 

    const answerType = info.answerType ?? ""
    
    const answerChoices = info.quizChoices ?? {}
    const userAnswer = info.quizUserAnswer ?? {}

    const isTotal = info.quizQuestion.toLowerCase().includes('total')

    const question = isTotal ? ( <strong>{ info.quizQuestion }</strong> ): info.quizQuestion

    /**
     * Hide answers for now
     */
    const handleClick = () => {
        if( isTotal ) return
        setIsCollapsed(( prev ) => !prev )
    }
    
    return (
        <div className='msync-question-container'>
            <div className='msync-question-containner__title'>
                {/* { !isTotal && (
                    ( isCollapsed ) ? (
                        <Icons type={'arrow-up'} width={"11"} height={"11"} /> 
                    ) : (
                        <Icons type={'arrow-down'} width={"11"} height={"11"} /> 
                    )
                )} */}
                { question }
            </div>
            {/* { isCollapsed && <Answer answerType={answerType} answerChoices={answerChoices} userAnswer={userAnswer} info={info} /> } */}
        </div>
    )
}

export default Question